import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import { Animated } from 'react-animated-css';

import StationSelector from '../../components/dashboard/StationSelector';
import FinanceTable from '../../components/finance/FinanceTable';
import BlopsSchedule from '../../components/finance/BlopsSchedule';
import SiteInfoCard from '../../components/dashboard/SiteInfoCard';

import './Finance.css';
import { initializeStation } from '../../utils/initStation';
import {
  getUserStationList,
  inspectionTimeUpdate
} from '../../modules/analytics';

class Finance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await initializeStation(this.props);
    this.setState({ loading: false });
  }

  render() {
    const { inspectionTime } = this.props;

    return (
      <Animated animationIn="fadeIn">
        <div className="financeWrapper" style={{ paddingBottom: this.props.play ? '100px' : '20px' }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={17} className="leftPanel">
              <StationSelector pageTitle="Finance" />
              <FinanceTable stationId={inspectionTime.stationId} />
            </Col>
            <Col xs={24} md={7} className="rightPanel">
              <SiteInfoCard />
              <BlopsSchedule />
            </Col>
          </Row>
        </div>
      </Animated>
    );
  }
}

const mapStateToProps = (state) => ({
  router: state.router,
  userProfile: state.user.userProfile,
  userStationList: state.analytics.userStationList,
  inspectionTime: state.analytics.inspectionTime,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserStationList,
      inspectionTimeUpdate,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Finance);
